require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#1B718A',
        secondary: '#04243B',
        accent: '#FFB100',
        colorWhite: '#F2F4F4',
        colorBlack: '#3B3B3B',
        colorGrey: '#919191',
        colorLightGrey: '#D5D5D5',
        error: '#A32828',
        warning: '#FFBA00',
        info: '#4854e0',
        success: '#4EB436',
        borderColor: '#EAEAEA',
        red: '#F44336',
        whatsapp: '#55CD6B',
        light: '#F2F4F4',
        dark: '#3B3B3B'
      },
      dark: {
        primary: '#1B718A',
        secondary: '#04243B',
        accent: '#FFB100',
        colorWhite: '#F2F4F4',
        colorBlack: '#3B3B3B',
        colorGrey: '#919191',
        colorLightGrey: '#D5D5D5',
        error: '#A32828',
        warning: '#FFBA00',
        info: '#4854e0',
        success: '#4EB436',
        borderColor: '#EAEAEA',
        red: '#F44336',
        whatsapp: '#55CD6B',
        light: '#F2F4F4',
        dark: '#3B3B3B'
      },
    },
  },
}
